<template>

    <img :src="`/screensaver/Diapositive${current}.png`" alt width="100%" />

</template>

<script>
export default {
  mounted() {
    this.imageChangeInterval = setInterval(this.imageChange, 5000);
  },
  beforeDestroy() {
    clearInterval(this.imageChangeInterval);
  },
  methods: {
    imageChange() {
      if (this.current < 7) {
        this.current += 1;
      } else {
        this.current = 1;
      }
    },
  },
  data: () => ({
    filenames: Array.from({ length: 7 }, (_, i) => i + 1),
    current: 1,
  }),
};
</script>
